module.exports = __webpack_public_path__ + "static/bg-day-e4248b473bf4e4a77ddd1e9d4b87dbb8.mp4";